// @flow

// Libs
import { createSelector } from 'reselect'
import _reduce from 'lodash/reduce'
import turfArea from '@turf/area'
import turfFlatten from '@turf/flatten'
import convert from 'convert-units'

// Selectors
import featureCollectionPerAsset$ from './featureCollectionPerAsset'

// Local
type Geometry = { type: string, coordinates: Array<*>, properties: Object }
type Feature = {
  type: 'Feature',
  properties: Object,
  geometry: Geometry
}

type FeatureCollection = {
  type: 'FeatureCollection',
  properties: Object,
  features: Array<Feature>
}

type FeatureCollectionPerAsset = {
  [string]: FeatureCollection
}

type Index = { [number]: number }

/* function isPolygon (feature: Object): boolean {
  return feature.geometry.type === 'Polygon'
} */

// Exports
export default (createSelector(
  [featureCollectionPerAsset$],
  function (featureCollectionPerAsset: FeatureCollectionPerAsset): Index {
    //
    return _reduce(
      // Reduce collection of featureCollections
      featureCollectionPerAsset,
      // Using this function
      function (acc: Index, featureCollection: FeatureCollection, assetId: string): Index {
        // $FlowFixMe
        try {
          const flattened = turfFlatten(featureCollection)
          if (flattened.features.length >= 1) {
            acc[assetId] = Math.round(convert(turfArea(flattened)).from('m2').to('ac'))
          } else {
            acc[assetId] = 0
          }
        } catch (error) {
          console.warn('Unable to merge overlapping GeoJSON in:')
          console.info(featureCollection.features)
          console.info('Calculated area will include overlap.')
          acc[assetId] = Math.round(convert(turfArea(featureCollection)).from('m2').to('ac'))
        }

        return acc
      }
      // With empty object as default - end of reduce
      , {})
  }
): Selector$<Index>)
